import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'

class AdminRenderCompetency extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
        	data: {
        		competencyName: '',
                competencyId: '',
                competencyDescription: ''
            },
            inputData: {
                competencyName: '',
                competencyDescription: ''
            },
            modifyView: 'default',
            errorMsg: ''
        };
    }

    handleNameChange = (event) => {
        let inputData = Object.assign({}, this.state.inputData)
        inputData.competencyName = event.target.value
        this.setState({inputData: inputData}) 
    }

    handleDescChange = (event) => {
        let inputData = Object.assign({}, this.state.inputData)
        inputData.competencyDescription = event.target.value
        this.setState({inputData: inputData}) 
    }

    handleModifySave = (e) => {
        e.preventDefault()
        if ((this.state.inputData.competencyName === '') || (this.state.inputData.competencyDescription === '')) {
            return this.setState({errorMsg: 'Please enter the necessary details before editing a Competency.'})
        }

        let data = {
            'mcCompetency':
                {
                    'name' : this.state.inputData.competencyName,
                    'description': this.state.inputData.competencyDescription
                }
        }

        api.adminCompetencyUpdate(this.props.user.accessToken, data, this.props.competencyId)
        .then((result) => {
            if(result.status === 'success'){
                let data = Object.assign({}, this.state.data)

                data.competencyId = result.data.competency.id
                data.competencyName = result.data.competency.name
                data.competencyDescription = result.data.competency.description
                let modifyView = 'default'
                this.props.onCompetencyUpdate(e)
                this.setState({data: data, modifyView: modifyView})
            }
            else{
                this.setState({ errorMsg: 'Error in modifying the existing competency.' })
            }
        }).catch((err) => {
            this.setState({ errorMsg: 'Error in modifying the competency. Please contact Admin!' })
        })
    }

    handleModifyCancel = (e) => {
        let modifyView
        modifyView = 'default'
        this.setState({modifyView: modifyView, errorMsg: ''})
    }


    handleUnlistedCompetencyView = (e, competencyName, competencyId) => {
        e.preventDefault()
        this.props.onhandleUnlistedCompetencyView(competencyName, competencyId)
    }

    handleCompetencyEditView = (e) => {
        let modifyView
        modifyView = 'edit_view'
        let inputData = Object.assign({}, this.state.inputData)
        inputData.competencyName = this.state.data.competencyName
        inputData.competencyDescription = this.state.data.competencyDescription
        this.setState({modifyView: modifyView, errorMsg: '', inputData: inputData})
    }

    componentDidMount() {
        let inputData = Object.assign({}, this.state.inputData)
        let data = Object.assign({}, this.state.data)
        inputData.competencyName = this.props.competencyName
        inputData.competencyDescription = this.props.competencyDescription
        data.competencyName = this.props.competencyName
        data.competencyDescription = this.props.competencyDescription
        this.setState({inputData: inputData, data: data})
    }

    render() {
        let handleUnlistedCompetencyView = this.handleUnlistedCompetencyView
        let handleCompetencyEditView = this.handleCompetencyEditView
        let componentView
        let handleModifyCancel = this.handleModifyCancel
        let handleModifySave = this.handleModifySave

        if(this.state.modifyView === 'default') {
            componentView = (
                <Grid>
                    <GridCell span="12">
                        <Typography align = "left"> {this.state.data.competencyName} </Typography>
                    </GridCell>
                    <GridCell span="4">
                        <button className="mdc-button" aria-label="Favorite" onClick= {((e) => handleCompetencyEditView(e))}>Edit </button>
                    </GridCell>
                    <GridCell span="4">
                    </GridCell>
                    <GridCell span="4">
                        <button className="mdc-button" aria-label="Favorite" onClick= {((e) => handleUnlistedCompetencyView(e, this.props.competencyName, this.props.competencyId))}>View </button>
                    </GridCell>
                </Grid>
            )
        }
        else if (this.state.modifyView === 'edit_view'){
            componentView = (
                <div>
                    <Grid>
                        <GridCell span="10">
                            <TextField fullwidth label ="Name of the Competency"  autoComplete="off"  name="name" value = {this.state.inputData.competencyName} onChange = {this.handleNameChange} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span ="10">
                            <TextField textarea fullwidth label="Enter a short description" rows="2" value = {this.state.inputData.competencyDescription} onChange = {this.handleDescChange} />
                        </GridCell>
                        <GridCell span = "4">
                            <Button raised style={{ width: '100%' }} onClick= {((e) => handleModifySave(e))}>Save</Button>
                        </GridCell>
                        <GridCell span = "4">
                            <Button raised style={{ width: '100%' }} onClick= {((e) => handleModifyCancel(e))}>Cancel</Button>
                        </GridCell>
                    </Grid>
                    <StatusMessage error_msg = {this.state.errorMsg} />
                </div>
            )
        }

    	return (
            <GridCell span="4">
                <Card style={{padding: '5px'}}>
                    {componentView}
                </Card>
            </GridCell>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminRenderCompetency);


// WEBPACK FOOTER //
// ./src/views/admin/AdminRenderCompetency.jsx